import { FindInPage } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { PageTitle } from "components/PageTitle";
import { GetOrdersQuery } from "components/gql/queris/GetOrders";
import { OrdersListQuery } from "components/gql/queris/GetOrdersList";
import { GetAlertData } from "contexts/AlertContext";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";
import {
  getFirstInArray,
  getOrdersByToken,
  isObjectEmpty,
  isToken,
  searchOrders,
} from "data/functions";
import React from "react";
// import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { OrderNumberField } from "./fileds/OrderNumberField";
import { OrderQrField } from "./fileds/OrderQrField";
import { PlateNumberField } from "./fileds/PlateNumberField";

export function OrdersSearch(props) {
  const [findParams, setFindParams] = React.useState({});
  const { dataObj, forceSetDataObj } = GetData();
  const { cInfo } = GetCInfo();
  const { setAlert } = GetAlertData();
  // const auth = useAuth();
  const navigate = useNavigate();
  const [getOrdersQuery] = GetOrdersQuery();
  const [ordersListQuery] = OrdersListQuery();

  async function localSearchOrders(findParams, companyUuid) {
    if (!findParams?.orderNumber && !findParams?.plate && !findParams?.code) {
      setAlert("Не заданы параметры поиска", "warn");
      return;
    }

    let orders = [];
    // if (findParams?.code) {
    //   if (isToken(findParams?.code)) {
    //     orders = await getOrdersByToken(
    //       findParams?.code,
    //       companyUuid,
    //       ordersListQuery,
    //       { dataObj, forceSetDataObj }
    //     );
    //     navigateOrders(orders);
    //     // return;
    //   }
    // }
    if (isObjectEmpty(orders)) {
      orders = await searchOrders(findParams, companyUuid, getOrdersQuery);
      // setAlert(
      //   "Внимание!. Вы получили тестовые данные. Функционал в разработке.",
      //   "warn",
      //   5
      // );
      navigateOrders(orders);
    }

    // if (isObjectEmpty(orders)) {
    //   setAlert("Не найдено документов с возможностью удаленной оплаты.");
    // }

    return;
  }

  function navigateOrders(orders) {
    if (orders?.length === 1) {
      let obj = getFirstInArray(orders);
      if (obj) {
        navigate(`/orders/${obj?.orderID}`, {
          state: {
            clientID: obj?.user?.id,
            orderID: obj?.orderID,
          },
        });
      }
    } else if (orders.length > 0) {
      navigate("/orders/list");
    }
    // else {
    //   setAlert("Не найдено документов с возможностью удаленной оплаты.");
    // }
  }

  return (
    <React.Fragment>
      <Box>
        <PageTitle home={false} title="Поиск документа" />
        <Box sx={{ height: "2px" }}>
          {/* {getOrdersVars?.loading && <LinearProgress sx={{ height: "2px" }} />} */}
        </Box>
      </Box>

      <Box
        sx={{
          alignSelf: "center",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          height: "100%",
          marginBottom: "auto",
          // height: "80%",
          // justifyContent: "center",
          marginTop: "auto",
          maxWidth: "820px",

          overflow: "auto",
          padding: "0.4rem",
          width: "100%",
        }}
      >
        {/* <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}> */}
        <OrderNumberField
          findParams={findParams}
          setFindParams={setFindParams}
        />
        <PlateNumberField
          findParams={findParams}
          setFindParams={setFindParams}
        />
        {/* </Box> */}

        <OrderQrField findParams={findParams} setFindParams={setFindParams} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            padding: "0.4em",
            // position: "absolute",
            width: "100%",
            zIndex: 2,
          }}
        >
          <Button
            fullWidth
            onClick={() => {
              // console.log(findParams);

              localSearchOrders(findParams, cInfo?.UUID);
            }}
            sx={{ padding: "0.4em" }}
            variant="outlined"
          >
            {/* <FindInPage /> */}
            Далее
          </Button>
          <Button
            fullWidth
            onClick={() => {
              navigate("/");
            }}
            sx={{ padding: "0.4em" }}
            variant="outlined"
          >
            {/* <FindInPage /> */}
            Отмена
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
}
